export const STORE_DETAILS_TAB_PARAM = 'sd_tab';

// Legacy param used before query param namespacing.
export const STORE_DETAILS_TAB_PARAM_LEGACY = 'tab';
